import type { RefObject } from 'react';
import { useEffect, useEffectEvent, useState } from 'react';

export const useIsOverflowing = (
  containerRef: RefObject<HTMLDivElement | null>
) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflowing = () => {
    if (containerRef.current) {
      const { scrollWidth, clientWidth } = containerRef.current;
      const updatedValue = scrollWidth > clientWidth;
      if (updatedValue !== isOverflowing) {
        setIsOverflowing(updatedValue);
      }
    }
  };

  const handleResize = useEffectEvent(() => {
    if (containerRef.current) {
      const { scrollWidth, clientWidth } = containerRef.current;
      const updatedValue = scrollWidth > clientWidth;
      if (updatedValue !== isOverflowing) {
        setIsOverflowing(updatedValue);
      }
    }
  });

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    const container = containerRef.current;
    container?.addEventListener('scroll', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      container?.removeEventListener('scroll', handleResize);
    };
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, []);

  checkOverflowing();

  return isOverflowing;
};
